/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MinimalTenant } from './MinimalTenant';
import {
    MinimalTenantFromJSON,
    MinimalTenantFromJSONTyped,
    MinimalTenantToJSON,
} from './MinimalTenant';
import type { ProductSku } from './ProductSku';
import {
    ProductSkuFromJSON,
    ProductSkuFromJSONTyped,
    ProductSkuToJSON,
} from './ProductSku';
import type { Subscription } from './Subscription';
import {
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
} from './Subscription';

/**
 * 
 * @export
 * @interface License
 */
export interface License {
    /**
     * 
     * @type {string}
     * @memberof License
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof License
     */
    readonly seatsFree: number;
    /**
     * 
     * @type {number}
     * @memberof License
     */
    readonly seatsInUse: number;
    /**
     * 
     * @type {number}
     * @memberof License
     */
    readonly deviceCount: number;
    /**
     * 
     * @type {ProductSku}
     * @memberof License
     */
    readonly product: ProductSku;
    /**
     * 
     * @type {Date}
     * @memberof License
     */
    readonly activationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof License
     */
    readonly expiryDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof License
     */
    readonly durationInDays: number;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    readonly licenseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof License
     */
    readonly device: string | null;
    /**
     * 
     * @type {Subscription}
     * @memberof License
     */
    readonly subscription: Subscription | null;
    /**
     * 
     * @type {boolean}
     * @memberof License
     */
    readonly isTransferable: boolean;
    /**
     * 
     * @type {MinimalTenant}
     * @memberof License
     */
    readonly tenant: MinimalTenant | null;
}

/**
 * Check if a given object implements the License interface.
 */
export function instanceOfLicense(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "seatsFree" in value;
    isInstance = isInstance && "seatsInUse" in value;
    isInstance = isInstance && "deviceCount" in value;
    isInstance = isInstance && "product" in value;
    isInstance = isInstance && "activationDate" in value;
    isInstance = isInstance && "expiryDate" in value;
    isInstance = isInstance && "durationInDays" in value;
    isInstance = isInstance && "licenseNumber" in value;
    isInstance = isInstance && "device" in value;
    isInstance = isInstance && "subscription" in value;
    isInstance = isInstance && "isTransferable" in value;
    isInstance = isInstance && "tenant" in value;

    return isInstance;
}

export function LicenseFromJSON(json: any): License {
    return LicenseFromJSONTyped(json, false);
}

export function LicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): License {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'seatsFree': json['seats_free'],
        'seatsInUse': json['seats_in_use'],
        'deviceCount': json['device_count'],
        'product': ProductSkuFromJSON(json['product']),
        'activationDate': (new Date(json['activation_date'])),
        'expiryDate': (json['expiry_date'] === null ? null : new Date(json['expiry_date'])),
        'durationInDays': json['duration_in_days'],
        'licenseNumber': json['license_number'],
        'device': json['device'],
        'subscription': SubscriptionFromJSON(json['subscription']),
        'isTransferable': json['is_transferable'],
        'tenant': MinimalTenantFromJSON(json['tenant']),
    };
}

export function LicenseToJSON(value?: License | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

